import { useConfirm } from 'hooks/useConfirm';
import { GlobalStyles, theme } from 'lib/theme';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { APIRemoteUrl } from 'service/api/constants';
import { AppContext, appContextToFileContext } from 'types/types';

import { useDispatch } from 'react-redux';
import { doFilePreview } from 'store/actions';
import { FileTypeExtensions } from 'service/file/types';
import { FileAddButtons } from './Field/FileAddButtons';
import { ICONS } from './Icon';
import { LocalThumbnail } from './Thumbnail/LocalThumbnail';
import { Avatar } from './Avatar';

type Props = {
  context: AppContext;
  size?: number;
  fileId: string | undefined;
  onChange: (id?: string) => void;
  removeConfirmTitle?: string;
  icon?: ICONS;
  editable: boolean;
  remoteUrl?: APIRemoteUrl;
  invalid: boolean;
};

export const ProfileAvatarField: React.FC<Props> = ({
  context,
  fileId,
  icon = ICONS.ImageThin,
  onChange,
  removeConfirmTitle,
  size = 150,
  editable,
  remoteUrl,
  invalid,
}) => {
  const dispatch = useDispatch();
  const confirm = useConfirm();

  const handleRemoveImage = () =>
    confirm({
      title: removeConfirmTitle || 'Remove Image',
      text: 'The image will remain available in RiskBase',
      onConfirm: onChange,
      destructive: true,
      confirmText: 'Remove',
    });
  const resolvedRemoteUrl = remoteUrl?.(fileId);
  return (
    <View style={styles.container}>
      {remoteUrl ? (
        <Avatar
          data={resolvedRemoteUrl ? { remoteUrl: resolvedRemoteUrl } : null}
          icon={icon}
          size={size}
          onPress={
            fileId
              ? () =>
                  dispatch(
                    doFilePreview({
                      fileId,
                      typeId: FileTypeExtensions.jpeg,
                      context: appContextToFileContext(context),
                    }),
                  )
              : undefined
          }
          style={invalid ? GlobalStyles.invalidFieldOutline : undefined}
        />
      ) : (
        <LocalThumbnail
          thumbnailId={fileId}
          width={size}
          height={size}
          rounded
          icon={icon}
          onPress={
            fileId
              ? () =>
                  dispatch(
                    doFilePreview({
                      fileId,
                      typeId: FileTypeExtensions.jpeg,
                      context: appContextToFileContext(context),
                    }),
                  )
              : undefined
          }
          style={invalid ? GlobalStyles.invalidFieldOutline : undefined}
        />
      )}
      {!!editable && (
        <FileAddButtons
          context={appContextToFileContext(context)}
          style={styles.fileAddButtons}
          type="images"
          promptMessage="Choose Image"
          onChange={(fileIds) => onChange(fileIds[0])}
          onRemove={fileId ? handleRemoveImage : undefined}
          removeText={removeConfirmTitle || 'Remove Image'}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  fileAddButtons: {
    marginTop: -theme.grid * 2,
    opacity: 0.95,
  },
});
